import React from "react";
import SubOption from "./SubOption";

export default function SubOptionList({
  addonId,
  optionId,
  subOptions,
  selectedSubOptions,
  onSubOptionChange,
  optionQuantity
}) {
  return (
    <div className='suboption-list'>
      {subOptions?.map((subOption) => (
        <SubOption
          key={subOption.subOptionId}
          addonId={addonId}
          optionId={optionId}
          subOption={subOption}
          selected={selectedSubOptions?.[subOption.subOptionId] || false}
          onChange={onSubOptionChange}
          optionQuantity={optionQuantity}
        />
      ))}
    </div>
  );
}
